import React, {Fragment} from 'react';
import {getPercentageFromTotal} from '../../../util/helpers';
import './estilos.css';

const degradeColors = ['#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f',
    '#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f',
    '#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f',
    '#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f',
    '#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f'
]

const styles = {
    rowHead: {
        backgroundColor: `#4d5a31`,
        borderColor: `#4d5a31`,
        color: '#474242 !important',
        borderWidth: '2px',
        borderStyle: 'solid'
    }

}

class GenericTable extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            data: [],
            headers: [],
            config: {
                dados: {},
                title: '',
                data_label: ''
            },
            downloading: false
        }
    }


    static getDerivedStateFromProps(props, state) {

        let dataFormatter = props.formatter;


        return {
            data: dataFormatter?.dataCollection,
            headers: dataFormatter?.headers,
            config: dataFormatter?.config,
        }
    }

    formatNumber = (number, precision = null) => {

        if (!precision) {
            precision = 0;
        }

        return new Intl.NumberFormat('pt-BR', {
            maximumFractionDigits: precision,
            minimumFractionDigits: precision
        }).format(Number(number));
    }

    componentDidMount() {

    }

    exportExcel = async () => {
        try {

            await this.setState({
                downloading: true
            });

            let payload = this.getExportFilePayload();

            let response = await axios.post(route('web.export.dados.sociodemografia'), payload, {
                responseType: 'blob'
            });

            let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            const fileName = response.headers['content-disposition'].split('filename=')[1];

            this.downloadBlob(blob, fileName);

        } catch (e) {
            console.log(e);
        } finally {
            this.setState({
                downloading: false
            });
        }

    }

    getExportFilePayload() {
        let dadosKeys = Object.keys(this.state.config?.dados);
        let collectionKeys = Object.keys(this.state.data);

        return {
            config: this.state.config,
            headers: this.state.headers,
            dadosKeys: dadosKeys,
            collectionKeys: collectionKeys,
            data: this.state.data
        };
    }

    exportPDF = async () => {
        try {

            this.setState({
                downloading: true
            });

            let payload = this.getExportFilePayload();
            let response = await axios.post(route('web.export_pdf.dados.sociodemografia'), payload, {
                responseType: 'blob'
            });

            let blob = new Blob([response.data], {
                type: 'application/pdf'
            });

            const fileName = response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '');

            this.downloadBlob(blob, fileName);


        } catch (e) {
            console.log(e);
        } finally {
            this.setState({
                downloading: false
            });
        }

    }

    downloadBlob = ( blob, filename ) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    getTotalCollumKey = (collectionKey) => {

        let key = 'total';


        if( this.state.config?.datalayerName === 'populacao' || this.state.config?.datalayerName === 'domicilios'){
            const populacaoKeys = [
                'nr_pessoas_2022_v0001',
                'nr_pessoas_proj_2025',
                'nr_populacao_0_4_anos_v01031',
                'nr_populacao_5_9_anos_v01032',
                'nr_populacao_10_14_anos_v01033',
                'nr_populacao_15_19_anos_v01034',
                'nr_populacao_20_24_anos_v01035',
                'nr_populacao_25_29_anos_v01036',
                'nr_populacao_30_39_anos_v01037',
                'nr_populacao_40_49_anos_v01038',
                'nr_populacao_50_59_anos_v01039',
                'nr_populacao_60_69_anos_v01040',
                'nr_populacao_70_anos_mais_v01041',
                'tx_pessoas_domicilios',
                'area_km2',
                'nr_densidade_demografica_hab_km2',
            ];

            if( populacaoKeys.includes(collectionKey) ){
                return 'nr_pessoas_2022_v0001';
            }

            return 'nr_domicilios_particulares_v0003';

        }


        return key;
    }

    render() {

        let dadosKeys = Object.keys(this.state.config?.dados);
        let collectionKeys = Object.keys(this.state.data);

        return (
            <div className="card card-results" id="table-sociodemografia-resultados" style={{height: 'auto'}}>
                <div style={{overflowX: 'scroll', padding: '10px'}}>
                    <table className="table table-striped table-condensed" style={{border: `2px solid ${styles.rowHead.backgroundColor}`}}>
                        <thead>
                            <tr style={styles.rowHead}>
                                <td style={{color: 'white', fontWeight: 'bold'}} className="text-center"
                                    colSpan={2 + (this.state.headers.length * 2)}>
                                    {this.state?.config?.title?.toUpperCase()}
                                </td>
                            </tr>
                            <tr style={styles.rowHead}>
                                <th style={{color: 'white', fontWeight: 'bold'}} rowSpan={2} scope="col"
                                    className="text-center">{this.state.config?.data_label}
                                </th>
                                {this.state.headers.map((header, index) => {

                                    return (
                                        <th key={`header-faixa-etaria-${index}`} colSpan={2}
                                            style={{color: 'white', fontWeight: 'bold'}} scope="col"
                                            className="text-center">
                                            {header}
                                        </th>
                                    );
                                })}
                            </tr>
                            {this.state.config.uses_subheader && <>
                                <tr style={styles.rowHead}>

                                    {this.state.headers.map((header, index) => {
                                        return (
                                            <Fragment key={`subheader-${header}-${index}`}>
                                                <th style={{color: 'white', fontWeight: 'bold'}} className="text-center">
                                                    Absoluto
                                                </th>
                                                <th style={{color: 'white', fontWeight: 'bold'}} className="text-center">
                                                    Percentual
                                                </th>
                                            </Fragment>
                                        );
                                    })}
                                </tr>
                            </>}
                        </thead>
                        <tbody>
                            {dadosKeys.map((key, index) => {
                                return (
                                    <Fragment key={`row-${key}-${index}`}>
                                        <tr style={{fontWeight: 'bold'}} className="text-center">
                                            <td>{this.state.config?.dados?.[key]}</td>

                                            {collectionKeys.map((collectionKey, indexTwo) => {

                                                const keyTotal = this.getTotalCollumKey(key);

                                                let total = this.state.data[collectionKey]?.items[0]?.[keyTotal];

                                                if( key === 'tx_indice_propriedade'){
                                                    total = 100;
                                                }

                                                let porcentagem = getPercentageFromTotal(
                                                    total,
                                                    this.state.data[collectionKey]?.items[0]?.[key]
                                                );

                                                let gradienteColor = degradeColors[indexTwo];


                                                return (
                                                    <Fragment key={collectionKey}>
                                                        <td className="text-center" style={{
                                                            borderColor: `${styles.rowHead.backgroundColor} !important`,
                                                            borderLeft: `${styles.rowHead.backgroundColor} 2px solid`,
                                                            borderRight: `${styles.rowHead.backgroundColor} 2px solid`
                                                        }}>
                                                            {this.formatNumber(this.state.data[collectionKey]?.items?.[0]?.[key])}
                                                        </td>
                                                        <td className="text-center" style={{
                                                            backgroundImage: `linear-gradient(to right, ${gradienteColor}, white)`,
                                                            backgroundRepeat: 'no-repeat',
                                                            backgroundSize: `${porcentagem}%`,
                                                            borderColor: `${styles.rowHead.backgroundColor} !important`,
                                                            borderRight: `${styles.rowHead.backgroundColor} 2px solid`
                                                        }}>
                                                            <div className="pg">
                                                                {this.formatNumber(porcentagem, 2)}%
                                                            </div>

                                                        </td>
                                                    </Fragment>
                                                )


                                            })}
                                        </tr>
                                    </Fragment>
                                );
                            })}
                        </tbody>
                        {!this.state.config.datalayerName &&
                            <tfoot>
                                <tr style={{borderTopWidth: '4px', ...styles.rowHead}} scope="col"
                                    className="text-center">
                                    <td style={{color: 'white', fontWeight: 'bold'}}>TOTAL</td>
                                    {collectionKeys.map((collectionKey, index) => {
                                        return (
                                            <Fragment key={collectionKey}>
                                                <td className="text-center" style={{color: 'white', fontWeight: 'bold'}}>
                                                    {this.formatNumber(this.state.data[collectionKey]?.items?.[0]?.['total'])}
                                                </td>
                                                <td className="text-center" style={{color: 'white', fontWeight: 'bold'}}>
                                                    100%
                                                </td>
                                            </Fragment>
                                        );
                                    })}
                                </tr>
                            </tfoot>
                        }
                    </table>

                    {this.state.config.more_info && <div className="alert alert-info">
                        <i className="fas fa-info-circle"></i> &nbsp;
                        {this.state.config.more_info}
                    </div>}
                    <div className="pull-right d-flex align-items-center" style={{gap: '10px'}}>
                        <button className="btn btn-default pull-right" onClick={this.exportExcel}>
                            Exportar Excel &nbsp;
                            <i className="fas fa-file-excel"></i>
                            &nbsp;
                            {this.state.downloading && <i className="fas fa-spinner fa-spin"></i>}

                        </button>
                        <button className="btn btn-default pull-right" onClick={this.exportPDF}>
                            Exportar PDF &nbsp;
                            <i className="fas fa-file-pdf"></i>
                            &nbsp;
                            {this.state.downloading && <i className="fas fa-spinner fa-spin"></i>}

                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default GenericTable;
